import PropTypes from 'prop-types';

const BackArrow = (props) => (
  <span className={props.className}>
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M13.4133 19.1115L14.6667 17.8581L9.70666 12.8892L8.81319 12.0003L9.70666 11.1115L14.6667 6.14257L13.4133 4.88924L6.30221 12.0003L13.4133 19.1115Z"
        fill="currentColor"
      />
    </svg>
  </span>
);

BackArrow.defaultProps = {
  className: '',
};

BackArrow.propTypes = {
  className: PropTypes.string,
};

export default BackArrow;
